import type { Article } from "~/types/drupal_jsonapi";
import { For, Suspense, createResource, Show } from "solid-js";
import { getAutopromoMagazineTeasers } from "~/lib/fetcher";
import imgProxy from "~/utils/imgproxy";

import IconSchedule from "~/img/icons/schedule.svg";
import IconKeyboardArrowRight from "~/img/icons/keyboard_arrow_right.svg";
import type { AutopromosRendererProps } from "./AutopromosRenderer";
import { urlRs } from "~/utils/url";
import { formatDateUStoFrenchShortString } from "~/utils/format";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function MagazineTeasers(props: AutopromosRendererProps) {
  const [nodes] = createResource<Article[]>(
    () => getAutopromoMagazineTeasers(),
    {
      deferStream: true,
      ssrLoadFrom: "server",
    },
  );

  return (
    <span class="menu-magazine-teasers">
      <span class="the-list">
        <Suspense>
          <For each={nodes()}>
            {(node) => (
              <article class="node-article-menu" data-test="article-card">
                <Show when={node.field_image.uri.url}>
                  <picture>
                    <source
                      media="(min-width: 1280px)"
                      srcset={imgProxy(
                        node.field_image.uri.url,
                        `size:335:143/resizing_type:fill`,
                      )}
                    />
                    <img
                      src={imgProxy(
                        node.field_image.uri.url,
                        `size:221:95/resizing_type:fill`,
                      )}
                      alt=""
                      height="95"
                      width="221"
                      loading="lazy"
                    />
                  </picture>
                </Show>
                <div class="content-article">
                  <span class="submitted">
                    <i aria-hidden="true" class="cog-icon">
                      <IconSchedule />
                    </i>{" "}
                    {node.field_reading_time} &nbsp;-&nbsp;{" "}
                    {formatDateUStoFrenchShortString(node.created)}
                  </span>
                  <p class="h3">{node.title}</p>
                </div>
                <a
                  href={urlRs("articles", node.path.alias)}
                  title={`Lire la suite de ${node.title}`}
                >
                  <i aria-hidden="true" class="cog-icon">
                    <IconKeyboardArrowRight />
                  </i>
                  <span class="legend">Lire la suite</span>
                </a>
              </article>
            )}
          </For>
        </Suspense>
      </span>
    </span>
  );
}

/*


</article>

 */
